import { render } from "./Flexmonster.vue?vue&type=template&id=c2162bde&scoped=true"
import script from "./Flexmonster.vue?vue&type=script&lang=js"
export * from "./Flexmonster.vue?vue&type=script&lang=js"

import "./Flexmonster.vue?vue&type=style&index=0&id=c2162bde&scoped=true&lang=css"
import "./Flexmonster.vue?vue&type=style&index=1&id=c2162bde&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2162bde"]])

export default __exports__
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerGears});
